export const isVertexOfBox = (predicate) => (vertex) => predicate(vertex.box);
